export const getJwt = () => getItemWithExpiry("app_jwt");
export const deleteJwt = () => localStorage.removeItem("app_jwt");
export const setJwt = (token: string, expiry: number) => setItemWithExpiry("app_jwt", token, expiry);
export function setItemWithExpiry(key: string, value: string, expiry: number) {
    localStorage.removeItem(key);

    const now = new Date();

    const item = {
        value: value,
        expiry: now.getTime() + expiry,
    }

    localStorage.setItem(key, JSON.stringify(item));
}

export function getItemWithExpiry(key: string) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
        return null;
    }

    try {
        const item = JSON.parse(itemStr);
        const now = new Date();

        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }

        return item.value;
    } catch (error) {
        localStorage.removeItem(key);
        return null;
    }
}